/**
 * Safely format a percentage value for display.
 * - Guards against NaN/null/undefined (returns 0).
 * - Guards against negative values from calculation bugs (returns 0).
 * - Does NOT clamp upper bound: values > 100% are legitimate in some contexts
 *   (e.g. over-enrollment: enrolled/quota can exceed 100%). Callers that need
 *   an upper bound should apply it explicitly.
 */
export function safePercentage(v: unknown): number {
	const n = Number(v);
	if (!Number.isFinite(n)) return 0;
	return Math.max(0, n);
}
